import React from 'react'
import { Box, Button, Divider, Stack, Typography } from '@mui/material'
import GoogleIcon from '../icon/GoogleIcon'
import { getSpecialFormHeaderActionSx } from './styles/specialFormHeaderActionSx'

export default function SpecialFormHeaderActions({
  title,
  description,
  helperText,
  actions = [],
  children,
  showDivider = true,
  actionsOnly = false,
  sx: rootSx
}) {
  const actionButtons =
    actions.length > 0 ? (
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={1.25}
        useFlexGap
        sx={{
          flexShrink: 0,
          width: { xs: '100%', md: 'auto' },
          alignItems: { xs: 'stretch', md: 'flex-end' }
        }}
      >
        {actions.map((action, index) => {
          const {
            key,
            label,
            type = 'button',
            variant = 'outlined',
            icon,
            iconPosition = 'start',
            iconProps = {},
            onClick,
            disabled = false,
            buttonProps = {},
            sx: actionSx
          } = action

          const buttonIcon = icon ? <GoogleIcon name={icon} size={24} {...iconProps} /> : null
          const baseSx = getSpecialFormHeaderActionSx(variant)

          return (
            <Button
              key={key || `${label}-${index}`}
              type={type}
              variant={variant}
              onClick={onClick}
              disabled={disabled}
              startIcon={iconPosition === 'start' ? buttonIcon : undefined}
              endIcon={iconPosition === 'end' ? buttonIcon : undefined}
              sx={{
                ...baseSx,
                ...actionSx,
                width: { xs: '100%', md: 'auto' },
                minWidth: { xs: 0, md: actionSx?.minWidth != null ? actionSx.minWidth : baseSx.minWidth }
              }}
              {...buttonProps}
            >
              {label}
            </Button>
          )
        })}
      </Stack>
    ) : null

  if (actionsOnly) return actionButtons

  return (
    <Box sx={{ mb: 3, ...rootSx }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', md: 'center' },
          gap: 2,
          flexDirection: { xs: 'column', md: 'row' }
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          {title && (
            <Typography
              sx={{ mb: description || helperText || children ? 0.75 : 0, fontSize: '20px' }}
            >
              {title}
            </Typography>
          )}

          {description && (
            <Typography sx={{ fontSize: '18px', lineHeight: 1.5 }}>{description}</Typography>
          )}

          {helperText && (
            <Typography sx={{ mt: 0.5, fontSize: '13px', color: '#8b92a0', lineHeight: 1.45 }}>
              {helperText}
            </Typography>
          )}

          {children}
        </Box>

        {actionButtons}
      </Box>

      {showDivider && <Divider sx={{ mt: 2, borderColor: '#000000' }} />}
    </Box>
  )
}
